export default function withLeadingZero(num) {
    return parseFloat(num) < 10 ? `0${num}` : `${num}`;
}
